import script from "./DelayList.vue?vue&type=script&setup=true&lang=ts&name=DelayList"
export * from "./DelayList.vue?vue&type=script&setup=true&lang=ts&name=DelayList"

const __exports__ = script;

export default __exports__